import { render, staticRenderFns } from "./TrendRecord.vue?vue&type=template&id=5fad75f9&scoped=true"
import script from "./TrendRecord.vue?vue&type=script&lang=js"
export * from "./TrendRecord.vue?vue&type=script&lang=js"
import style0 from "./TrendRecord.vue?vue&type=style&index=0&id=5fad75f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad75f9",
  null
  
)

export default component.exports